export default __webpack_public_path__ + "static/media/Google.bf972ff4.svg";